import { render, staticRenderFns } from "./top.vue?vue&type=template&id=4c03e59f&scoped=true"
var script = {}
import style0 from "./top.vue?vue&type=style&index=0&id=4c03e59f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c03e59f",
  null
  
)

export default component.exports